export const getBackgroundColor = (viewed, viewedError) => {
  if (viewed) {
    return 'success.main';
  }
  if (viewedError) {
    return 'error.main';
  }
  return '#eeeeee';
};

export const getTextColor = (viewed, viewedError) => {
  if (viewed) {
    return 'primary.contrastText';
  }
  if (viewedError) {
    return 'error.contrastText';
  }
  return 'inherit';
};
